import { TranslationService } from '@/utils/services/TranslationService';

import { NOTIFICATIONS } from '@/lib/routes/privateRoutes';

// Layout
import { WrapperSwitchLayout } from '@/components/layouts/wrappers/WrapperSwitchLayout';
// Components
import Content from '@/components/pages/notifications/Content';

const NotificationCenter = () => {
    return (
        <WrapperSwitchLayout>
            <Content />
        </WrapperSwitchLayout>
    );
};

export const getStaticProps = TranslationService.getTranslationMessagesFromRoute(NOTIFICATIONS);

export default NotificationCenter;
